import React, { useEffect, useId, useRef } from 'react';
import { MESSAGE_TEXT_COLOR, messageColor } from '../shared/exchangeIntroduction';
import './ExchangeIntroduction.css';

export function ExchangeIntroMessage({ message }) {
  const color = messageColor(message.backgroundColor);
  return <section className="exchange-intro-message" style={{ backgroundColor: `${color}33`, borderColor: `${color}66`, color: MESSAGE_TEXT_COLOR }}>
    <p>{message.text}</p>
  </section>;
}

export function ExchangeIntroDialog({ value, onConfirm, onCancel, busy = false }) {
  const dialog = useRef(null);
  const id = useId();
  useEffect(() => {
    const element = dialog.current;
    const previous = document.activeElement;
    element.showModal();
    return () => { element.close(); previous?.focus(); };
  }, []);
  return <dialog ref={dialog} className="exchange-intro-dialog" aria-labelledby={`${id}-title`} aria-describedby={`${id}-text`}
    style={{ backgroundColor: '#ffffff', color: value.textColor }}
    onCancel={event => { event.preventDefault(); if (!busy) onCancel(); }}>
    <h2 id={`${id}-title`}>{value.title}</h2>
    <p id={`${id}-text`}>{value.text}</p>
    <div className="exchange-intro-dialog-actions">
      <button type="button" disabled={busy} onClick={onCancel} style={{ backgroundColor: '#ffffff', color: value.textColor }} autoFocus>{value.cancelLabel}</button>
      <button type="button" disabled={busy} onClick={onConfirm} style={{ backgroundColor: value.buttonColor, color: value.buttonTextColor }}>{value.confirmLabel}</button>
    </div>
  </dialog>;
}
